document.addEventListener('DOMContentLoaded', function() {
  if (window.hasRunFiftyFiftySlider) {
    return; 
  }
  window.hasRunFiftyFiftySlider = true;

  function adjustSliders() {
    if (window.innerWidth < 992) {
      const sliders = document.querySelectorAll('.js-mobile-fifty-fifty-slider');

      sliders.forEach((slider) => {
        slider.classList.remove('d-flex');
        const sliderIndex = slider.getAttribute('data-slider-index');

        if (!slider.classList.contains('splide')) {
          slider.classList.add('splide');

          const splideTrack = document.createElement('div');
          splideTrack.className = 'splide__track';

          const splideList = document.createElement('ul');
          splideList.className = 'splide__list';

          while (slider.firstChild) {
            const item = slider.firstChild;
            const listItem = document.createElement('li');
            listItem.className = 'splide__slide';
            listItem.appendChild(item);
            splideList.appendChild(listItem);
          }

          splideTrack.appendChild(splideList);
          slider.appendChild(splideTrack);
          
          const splide = new Splide(slider, {
            type: "fade",
            rewind: true,
          });

          splide.on('mounted', () => {
            setupObserver(slider, splide, sliderIndex);
          });

          splide.on('moved', () => {
            updateProgressBar(slider, splide, sliderIndex); 
          });

          splide.mount();
        }
      });
    }
  }

  function setupObserver(slider, splideInstance, sliderIndex) {
    const fiftyFiftyElement = slider.closest('.js-fifty-fifty');

    if (fiftyFiftyElement) {
      const observer = new IntersectionObserver((entries) => {
        entries.forEach(entry => {
          if (entry.isIntersecting && fiftyFiftyElement.classList.contains('aos-animate')) {
            updateProgressBar(slider, splideInstance, sliderIndex);
          }
        });
      }, {
        threshold: 0.5 
      });

      observer.observe(fiftyFiftyElement);
    }
  }

  function updateProgressBar(slider, splideInstance, sliderIndex) {
    const progressBars = slider.closest('.js-fifty-fifty').querySelectorAll(`.js-fifty-fifty-progress-bar[data-slider-index="${sliderIndex}"]`);

    progressBars.forEach((progressBar) => {
      const progressBarIndex = parseInt(progressBar.getAttribute('data-index'), 10) - 1;

      if (progressBarIndex === splideInstance.index) {
        startProgressBar(progressBar, splideInstance);
      } else {
        resetProgressBar(progressBar); 
      }
    });
  }

  function startProgressBar(progressBar, splideInstance) {
    const progressSpan = progressBar.querySelector("span");

    if (progressSpan && !progressBar.classList.contains('animating')) {
      progressBar.classList.add('animating');
      
      progressSpan.style.transition = "width 5s linear";
      progressSpan.style.width = "100%"; 

      progressSpan.addEventListener('transitionend', function onTransitionEnd() {
        progressSpan.removeEventListener('transitionend', onTransitionEnd);
        progressBar.classList.remove('animating');
        splideInstance.go('>');
      });
    }
  }
  
  function resetProgressBar(progressBar) {
    const progressSpan = progressBar.querySelector("span");
    if (progressSpan) {
      progressSpan.style.transition = "none";
      progressSpan.style.width = "0%";
    }
    progressBar.classList.remove('animating');
  }

  adjustSliders();
});